module.exports = __webpack_public_path__ + "assets/img/1.1a8a3a8e.png";